module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: [_vm.cssClass],
    attrs: {
      "role": "complementary",
      "id": (_vm.cssClass + "-" + _vm.id)
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    class: [(_vm.cssClass + "-backdrop")],
    style: ({
      backgroundImage: ("url(" + _vm.backdrop + ")")
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('vc-style', [_vm._v("\n  #" + _vm._s(_vm.cssClass) + "-" + _vm._s(_vm.id) + " {\n    color: " + _vm._s(_vm.color) + ";\n    background-color: " + _vm._s(_vm.bgColor) + ";\n  }\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a30cef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-parallax/section.vue
// module id = 45
// module chunks = 1